import { Typography } from "@packages/ds";
import styled from "styled-components";

import InputDs from "ds/Input";

export const DefaultBranchLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  justify-content: space-between;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  margin-bottom: 40px;
  flex-direction: column;

  img {
    max-width: 40px;
    max-height: 40px;
    margin-bottom: 16px;
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 24px;
  }
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const Form = styled.div`
  flex: 1;
  .field,
  .dropdown .input-wrapper {
    margin-bottom: 24px;
    width: 316px;
  }
  .dropdown .input-wrapper .select-box {
    width: 316px;
    .select-box__placeholder {
      color: var(--section-granite-color, var(--granite));
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 24px 0;

  button + button {
    margin-left: 10px;
  }
`;

export const NameInputPrefix = styled.div`
  white-space: nowrap;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: -15px;
  color: var(--section-granite-color, var(--granite));
`;

export const NameInputPrefixValue = styled.span`
  color: var(--section-slate-color, var(--slate));
`;

export const Input = styled(InputDs)`
  margin-bottom: 16px;
`;
